/**
 * @lines98/client/lib/min-interval-gate — анти-спам троттл «не чаще раза в окно».
 *
 * ЗАЧЕМ / WHY THIS EXISTS (leaderboard focus-refresh 2026-06-11): авто-refresh активной
 * страницы лидерборда по возврату фокуса/вкладки (owner-decision «свежесть при открытии +
 * возврате фокуса») не должен бить по сети при ЧАСТЫХ focus/visibilitychange-событиях
 * (alt-tab дёрганье, оконные менеджеры шлют серию). Нужен простой ВРЕМЕННОЙ троттл: пускать
 * действие лишь если с прошлого пуска прошло ≥ интервала. Вынесен в модуль (не inline в
 * экране), т.к. это переиспользуемая «ручка» — любой focus-refresh surface может опереться
 * (модель «ствол → ветки», code-structure §3).
 *
 * SCOPE: чистая логика гейта на инжектируемых часах (`now`) — тестируема без таймеров/DOM.
 * NOT IN SCOPE: сам refresh (это вызывающий), дедуп параллельных сетевых полётов (это
 * `services/leaderboard-prefetch.sharedLeaderboardPane`) — троттл поверх дедупа, против ЧАСТОТЫ.
 *
 * Cross-references:
 *   - screens/leaderboard-screen.ts (consumer: focus/visible авто-refresh).
 */

/** Гейт «пускать не чаще раза в `intervalMs`» на инжектируемых часах. */
export interface MinIntervalGate {
  /**
   * Прошёл ли интервал с прошлого зачёта? `true` → пускаем И помечаем `now` как последний
   * пуск (следующий зачёт пройдёт лишь через интервал). `false` → слишком часто, no-op.
   * Первый вызов всегда `true` (ещё не пускали).
   * @param now — ms epoch (инжектируемые часы; по умолчанию `Date.now()`).
   */
  allow(now?: number): boolean;
}

/**
 * Создать троттл-гейт с минимальным интервалом `intervalMs`. Хранит ms последнего
 * разрешённого пуска (или `null` до первого) — чистая логика, без таймеров.
 */
export function createMinIntervalGate(intervalMs: number): MinIntervalGate {
  let lastAt: number | null = null;
  return {
    allow(now: number = Date.now()): boolean {
      if (lastAt !== null && now - lastAt < intervalMs) return false;
      lastAt = now;
      return true;
    },
  };
}
